import { Context } from "effect";

/** Keep the public service identity literal while sharing its fixed prefix. */
export const workerstationService = <Self, Shape>() => <const Name extends string>(name: Name) =>
  Context.Service<Self, Shape>()(`workerstation/${name}`);

